import { cn } from '~/lib/cn';

export const STICKY_TABLE_HEADER_CLASSES = cn(
  // Calculation for "top" = var(--sticky-header-height) + border-spacing-y-sm
  'sticky top-[calc(var(--sticky-header-height)+var(--spacing-sm))] z-10 will-change-[top]',
);
